<footer class="flex flex-wrap justify-center bg-white p-4 gap-4">
  <span class="text-sm text-black font-light">Phone: <a href="tel:+1844712-6777">+1 (844) 712-6777</a></span>
  <span class="text-sm text-black font-light"
    >Email: <a href="mailto:intervucoordinator@forsta.com">coordination&#64;forsta.com</a></span
  >
</footer>
